import dateFns from 'date-fns/locale/ko';

export default {
  dateFns,

  format: {
    date: 'yyyy/M/d',
    time: 'a hh시 mm분',
    dateTime: '$t(format:date) $t(format:time)',
    longDate: "MMMMd'일'",
    longDateTime: "MMMMd'일 ' a hh시 mm분",
    fullDate: 'yyyy년M월d일',
    fullDateTime: 'yyyy년M월d일 a hh시 mm분',
  },

  translation: {
    common: {
      aboutPlanka: 'Planka에 대해서',
      account: '계정',
      actions: '활동',
      addAttachment_title: '첨부 파일 추가',
      addComment: '댓글',
      addManager_title: '매니저 추가',
      addMember_title: '멤버 추가',
      addUser_title: '사용자 추가',
      administrator: '관리자',
      all: '모두',
      allChangesWillBeAutomaticallySavedAfterConnectionRestored:
        '연결이 복원되면<br />모든 변경 사항이 자동으로 저장됩니다.',
      areYouSureYouWantToDeleteThisAttachment: '해당하는 첨부 파일을 삭제하시겠습니까?',
      areYouSureYouWantToDeleteThisBoard: '해당하는 보드를 삭제하시겠습니까?',
      areYouSureYouWantToDeleteThisCard: '해당하는 항목카드를 삭제하시겠습니까?',
      areYouSureYouWantToDeleteThisComment: '해당하는 댓글을 삭제하시겠습니까?',
      areYouSureYouWantToDeleteThisLabel: '해당하는 라벨을 삭제하시겠습니까?',
      areYouSureYouWantToDeleteThisList: '해당하는 목록를 삭제하시겠습니까?',
      areYouSureYouWantToDeleteThisProject: '해당하는 프로젝트를 삭제하시겠습니까?',
      areYouSureYouWantToDeleteThisTask: '해당하는 업무를 삭제하겠습니까?',
      areYouSureYouWantToDeleteThisUser: '해당하는 사용자를 삭제하겠습니까?',
      areYouSureYouWantToLeaveBoard: '이 보드에서 나가시겠습니까?',
      areYouSureYouWantToLeaveProject: '이 프로젝트에서 나가시겠습니까?',
      areYouSureYouWantToRemoveThisManagerFromProject:
        '해당하는 프로젝트에서 매니저를 제거하시겠습니까?',
      areYouSureYouWantToRemoveThisMemberFromBoard: '해당하는 멤버를 보드에서 삭제하시겠습니까?',
      attachment: '첨부',
      attachments: '첨부 파일',
      authentication: '인증',
      background: '배경',
      board: '보드',
      boardNotFound_title: '보드를 찾을 수 없습니다',
      canComment: '댓글을 작성할 수 있습니다',
      canEditContentOfBoard: '보드 콘텐츠를 수정할 수 있습니다.',
      canOnlyViewBoard: '보드를 읽기만 할 수 있습니다.',
      cardActions_title: '카드 작업',
      cardNotFound_title: '카드를 찾을 수 없습니다',
      cardOrActionAreDeleted: '카드 또는 작업이 삭제되었습니다.',
      color: '색상',
      createBoard_title: '보드 생성',
      createLabel_title: '라벨 생성',
      createNewOneOrSelectExistingOne: '새로 생성하거나<br />기존 항목을 선택하세요.',
      createProject_title: '프로젝트 생성',
      createTextFile_title: '텍스트 파일 생성',
      currentPassword: '현재 비밀번호',
      dangerZone_title: '위험 구역',
      date: '날짜',
      dueDate_title: '마감일',
      deleteAttachment_title: '첨부 파일 삭제',
      deleteBoard_title: '보드 삭제',
      deleteCard_title: '카드 삭제',
      deleteComment_title: '댓글 삭제',
      deleteLabel_title: '라벨 삭제',
      deleteList_title: '목록 삭제',
      deleteProject_title: '프로젝트 삭제',
      deleteTask_title: '업무 삭제',
      deleteUser_title: '사용자 삭제',
      description: '설명',
      detectAutomatically: '자동으로 감지',
      dropFileToUpload: '업로드할 파일 놓기',
      editor: '편집기',
      editAttachment_title: '첨부 수정',
      editAvatar_title: '아바타 수정',
      editBoard_title: '보드 수정',
      editDueDate_title: '마감일 수정',
      editEmail_title: '이메일 수정',
      editInformation_title: '정보 수정',
      editLabel_title: '라벨 수정',
      editPassword_title: '비밀번호 수정',
      editPermissions_title: '권한 수정',
      editStopwatch_title: '스톱워치 수정',
      editUsername_title: '사용자 이름 수정',
      email: '이메일',
      emailAlreadyInUse: '이미 사용 중인 이메일입니다',
      enterCardTitle: '카드 제목 입력... [Ctrl+Enter]로 자동으로 열 수 있습니다.',
      enterDescription: '설명 입력...',
      enterFilename: '파일 이름 입력',
      enterListTitle: '목록 제목 입력...',
      enterProjectTitle: '프로젝트 제목 입력',
      enterTaskDescription: '업무 설명 입력...',
      filterByLabels_title: '라벨로 필터링',
      filterByMembers_title: '멤버로 필터링',
      fromComputer_title: 'PC에서',
      fromTrello: '트렐로에서',
      general: '일반',
      hours: '시',
      importBoard_title: '보드 가져오기',
      invalidCurrentPassword: '현재 비밀번호가 일치하지 않습니다',
      labels: '라벨',
      language: '언어',
      leaveBoard_title: '보드 떠나기',
      leaveProject_title: '프로젝트 떠나기',
      list: '목록',
      listActions_title: '목록 항목 조율',
      managers: '매니저',
      members: '멤버',
      minutes: '분',
      moveCard_title: '카드 옮기기',
      name: '이름',
      newEmail: '새로운 이메일',
      newPassword: '새로운 비밀번호',
      newUsername: '새로운 사용자 이름',
      noConnectionToServer: '서버에 연결할 수 없습니다',
      noBoards: '보드가 존재하지 않습니다',
      noLists: '목록이 존재하지 않습니다',
      noProjects: '프로젝트가 존재하지 않습니다',
      notifications: '알림',
      noUnreadNotifications: '확인하지 않은 알림이 없습니다.',
      openBoard_title: '보드 열기',
      optional_inline: '옵션',
      organization: '조직',
      phone: '전화번호',
      preferences: '환경설정',
      pressPasteShortcutToAddAttachmentFromClipboard:
        '팁: 클립보드에서 첨부 파일을 추가하려면 Ctrl-V (Mac의 경우 Cmd-V)를 누릅니다.',
      project: '프로젝트',
      projectNotFound_title: '프로젝트를 찾을 수 없습니다',
      removeManager_title: '매니저 삭제',
      removeMember_title: '멤버 삭제',
      searchLabels: '라벨 검색...',
      searchMembers: '멤버 검색...',
      searchUsers: '사용자 검색...',
      seconds: '초',
      selectBoard: '보드 선택',
      selectList: '목록 선택',
      selectPermissions_title: '권한 선택',
      selectProject: '프로젝트 선택',
      settings: '설정',
      stopwatch: '스톱워치',
      subscribeToMyOwnCardsByDefault: '기본적으로 내 카드를 구독합니다',
      taskActions_title: '업무 조율',
      tasks: '업무',
      thereIsNoPreviewAvailableForThisAttachment: '이 첨부 파일은 미리 보기를 사용할 수 없습니다.',
      time: '시간',
      title: '제목',
      userActions_title: '사용자 조율',
      userAddedThisCardToList: '<0>{{user}}</0>님이 <1>{{list}}에 카드를 추가했습니다</1>',
      userLeftNewCommentToCard:
        '{{user}}님이 <2>{{card}}</2>에 «{{comment}}»라는 댓글을 남겼습니다',
      userMovedCardFromListToList:
        '{{user}}님이 {{fromList}}에서 {{toList}}로 <2>{{card}}</2>를 옮겼습니다',
      userMovedThisCardFromListToList:
        '<0>{{user}}</0><1> 님이 {{fromList}}에서 {{toList}}로 이 카드를 옮겼습니다</1>',
      username: '사용자 이름',
      usernameAlreadyInUse: '이미 사용중인 사용자 이름입니다',
      users: '사용자',
      version: '버전',
      viewer: '열람자',
      writeComment: '댓글 쓰기...',
    },

    action: {
      addAnotherCard: '다른 카드 추가',
      addAnotherList: '다른 목록 추가',
      addAnotherTask: '다른 업무 추가',
      addCard: '카드 추가',
      addCard_title: '카드 추가',
      addComment: '댓글 추가',
      addList: '목록 추가',
      addMember: '멤버 추가',
      addMoreDetailedDescription: '자세한 설명 추가',
      addTask: '업무 추가',
      addToCard: '카드에 추가',
      addUser: '사용자 추가',
      createBoard: '보드 생성',
      createFile: '파일 생성',
      createLabel: '라벨 생성',
      createNewLabel: '새로운 라벨 생성',
      createProject: '프로젝트 생성',
      delete: '삭제',
      deleteAttachment: '첨부 삭제',
      deleteAvatar: '아바타 삭제',
      deleteBoard: '보드 삭제',
      deleteCard: '카드 삭제',
      deleteCard_title: '카드 삭제',
      deleteComment: '댓글 삭제',
      deleteImage: '이미지 삭제',
      deleteLabel: '라벨 삭제',
      deleteList: '목록 삭제',
      deleteList_title: '목록 삭제',
      deleteNotifications: 'Dismiss all',
      deleteProject: '프로젝트 삭제',
      deleteProject_title: '프로젝트 삭제',
      deleteTask: '업무 삭제',
      deleteTask_title: '업무 삭제',
      deleteUser: '사용자 삭제',
      edit: '수정',
      editDueDate_title: '마감일 수정',
      editDescription_title: '설명 수정',
      editEmail_title: '이메일 수정',
      editInformation_title: '정보 수정',
      editPassword_title: '비밀번호 수정',
      editPermissions: '권한 수정',
      editStopwatch_title: '스톱워치 수정',
      editTitle_title: '제목 수정',
      editUsername_title: '사용자 이름 수정',
      hideDetails: '세부 사항 숨기기',
      import: '가져오기',
      leaveBoard: '보드 나가기',
      leaveProject: '프로젝트 나가기',
      logOut_title: '로그아웃',
      makeCover_title: '커버 만들기',
      move: '이동',
      moveCard_title: '카드 이동',
      remove: '제거',
      removeBackground: '배경 제거',
      removeCover_title: '커버 제거',
      removeFromBoard: '보드 제거',
      removeFromProject: '프로젝트 제거',
      removeManager: '매니저 제거',
      removeMember: '멤버 제거',
      save: '저장',
      showAllAttachments: '모든 첨부 파일 표시 ({{hidden}} 숨겨짐)',
      showDetails: '세부 사항 표시',
      showFewerAttachments: '일부 첨부 파일만 표시',
      start: '시작',
      stop: '종료',
      subscribe: '구독',
      unsubscribe: '구독 취소',
      uploadNewAvatar: '새로운 아바타 업로드',
      uploadNewImage: '새로운 이미지 업로드',
    },
  },
};
